import { TPaginationParams, TResponse } from '../../../common/types';
import { superAppApi } from '../../../core';

import { AssignedOfferResponse, AssignOfferPayload, IStaff } from '../types';

const staffApi = superAppApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getStaffList: build.query<IStaff[], TPaginationParams>({
      query: ({ page, limit }) => ({
        url: '/staff',
        method: 'GET',
        params: { page, limit },
      }),
      transformResponse: (response: TResponse<IStaff[]>) => response.data,
      providesTags: ['Staff'],
    }),
    getStaffOffers: build.query<AssignedOfferResponse[], { id: string }>({
      query: ({ id }) => ({
        url: `/staff/${id}/offers`,
      }),
      transformResponse: (result: TResponse<AssignedOfferResponse[]>) =>
        result.data,
      providesTags: ['Offers'],
    }),
    assignOffer: build.mutation<void, AssignOfferPayload>({
      query: ({ id, ...payload }) => ({
        url: `/staff/${id}/offers`,
        method: 'POST',
        body: { ...payload },
      }),
      invalidatesTags: ['Offers'],
    }),
    unassignOffer: build.mutation<void, { id: string; offer_id: string }>({
      query: ({ id, offer_id }) => ({
        url: `/staff/${id}/offers`,
        method: 'PATCH',
        body: { offer_id },
      }),
      invalidatesTags: ['Offers'],
    }),
  }),
});

export const {
  useGetStaffListQuery,
  useGetStaffOffersQuery,
  useAssignOfferMutation,
  useUnassignOfferMutation,
} = staffApi;
